import React from 'react';
import { Card, CardMedia, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import i18next from 'i18next';
import Btn from '../global/Buttons/Btn';

const ItemCat = ({ product }) => {
  const navigate = useNavigate();
  const lng = i18next.language;

  return (

    <>
      <Card
        sx={{
          height: '100%',              // يملأ ارتفاع الـ Grid item
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '16px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          cursor: 'pointer',
          m: 2,
          direction: lng === 'en' ? 'ltr' : "rtl",
          maxWidth: { xs: '320px', md: '100%' },
          mx: 'auto',
          '&:hover': {
            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2)',
          },
        }}
        onClick={() => navigate(`/products/${product?.slug}`)}
      >
        <CardMedia
          component="img"
          image={product?.file}
          alt={product?.name}
          sx={{
            objectFit: 'contain',
            width: '100%',
            aspectRatio: '1 / 1',
          }}
        />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#F3F3F3',
            p: 2,
            textAlign: lng === 'ar' ? 'right' : 'left',
          }}
        >
          <Box sx={{ display: 'flex', gap: 0, alignItems: { md: 'unset', xs: 'flex-start' }, flexDirection: 'column' }}>
            <Typography variant='h6' color={'primary.bold'} >{product?.name}</Typography>
          </Box>
          {/* زر المزيد */}
          <Box sx={{ mt: 'auto' }}>
            <Btn path={`/products/${product?.slug}`} text={lng === 'ar' ? 'اكتشف المزيد' : 'Discover More'} />
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default ItemCat;
